import { render, staticRenderFns } from "./noticia.vue?vue&type=template&id=287345bd&scoped=true"
import script from "./noticia.vue?vue&type=script&lang=js"
export * from "./noticia.vue?vue&type=script&lang=js"
import style0 from "./noticia.vue?vue&type=style&index=0&id=287345bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287345bd",
  null
  
)

export default component.exports